export default __webpack_public_path__ + "48a54bf.png";